/*
 * @Description: 应用间的store
 * @Date: 2021-09-18 15:15:46
 */
import { initGlobalState } from 'qiankun';
import { reactive } from 'vue';

// 父应用的初始state
const initialState = reactive({
  ignore: 'master',
  token: '',
  user: {
    name: '',
    id: 0
  },
  menus: [], // 菜单
  rules: [] // 权限
});

const store = initGlobalState(initialState); // onGlobalStateChange setGlobalState offGlobalStateChange

/**
 * @description: 监听更变后的值并同步修改入state中
 * @param {any} 更变后的值
 * @param {any} 更变前的值
 * @return {void}
 */
store.onGlobalStateChange(newState => {
  // if (process.env.VUE_APP_SCENE !== 'online') {
  //   console.log(
  //     'main change',
  //     JSON.stringify(newState),
  //     JSON.stringify(preState)
  //   );
  // }
  // 需手动赋值
  for (var key in newState) {
    initialState[key] = newState[key];
  }
});

/**
 * @description: 新增 获取state下的属性
 * @param {string} 有key，表示取globalState下的某个子级对象。 无key，表示取全部
 * @return {any} value或者state
 */
store.getGlobalState = key => {
  return key ? initialState[key] : initialState;
};

export default store;
